import React from "react";
import { BrowserRouter, Switch, Redirect, Route, Link, NavLink } from "react-router-dom";

export class MaratonPobjednici extends React.Component {

    constructor(props) {
        super(props);
        this.state = { rezultati: null, loading: true };


        this.fetchData = this.fetchData.bind(this);
        this.setData = this.setData.bind(this);
        this.renderPobjednike = this.renderPobjednike.bind(this);
        this.renderPobjednikRow = this.renderPobjednikRow.bind(this);


        this.fetchData();
    }



    fetchData() {
        this.props.showLoadingFn(true);

        var promises = Promise.all([casino.repos.casinoMaratonRepo.get(true, null)]);

        this.dataPromises = casino.utils.makeCancelablePromise(promises);
        this.dataPromises.promise.then(this.setData, function (reason) { });
    }
    componentWillUnmount() {
        if (this.dataPromises)
            this.dataPromises.cancel();
    }
    setData(data) {
        var [maraton] = data;

        this.setState({
            pobjednici: maraton.rezultati,
            loading: false
        });

        this.props.showLoadingFn(false);
    }

    renderPobjednike() {
        return <table className="table-1 v2 v3">
            <thead>
                <tr>
                    <th className="text-left text text-6">Datum</th>
                    <th className="mobile-visible text-left text text-6">Igrač/Igra</th>
                    <th className="mobile-hidden text-left text text-6">Igrač</th>
                    <th className="mobile-hidden text-left text text-6">Igra</th>
                    <th className="text-right text text-6">Dobitak</th>
                </tr>
            </thead>
            <tbody>
                {(!this.state || !this.state.pobjednici) && <tr className="horizontal-lines"><td colSpan="5"><span className="text text-1">Dohvaćanje dobitnika...</span></td></tr>}

                {this.state && this.state.pobjednici && !this.state.pobjednici.length && <tr className="horizontal-lines"><td colSpan="5"><span className="text text-1">Trenutno nema rezultata...</span></td></tr>}
                {this.state && this.state.pobjednici && this.state.pobjednici.map(this.renderPobjednikRow)}
            </tbody>
        </table>
    }
    renderPobjednikRow(pobjednik, i) {
        var datum = new Date(pobjednik.datum);

        if (i > 20)
            return null;

        return (
            <tr key={i} className="horizontal-lines">
                <td>
                    <span className="text text-1">{casino.utils.dateToTimeString(datum)}</span><br />
                    <span className="text text-2">
                        {datum.getDate() + '.' + (datum.getMonth() + 1) + '.'}
                    </span>
                </td>
                <td className="mobile-visible text text-1">
                    <span className="text-bold">{pobjednik.igrac}</span><br /> <span className="text text-2 ">{pobjednik.igraNaziv}</span>
                </td>
                <td className="mobile-hidden text text-1 text-bold">{pobjednik.igrac}</td>
                <td className="mobile-hidden text text-1">{pobjednik.igraNaziv}</td>
                <td>
                    <div className="dobitak-iznos gold pull-right smaller" >
                        <div className="iznos text-ellipsis">{casino.utils.switchKnToEur(casino.utils.numberToString(pobjednik.dobitak))}<span className="kn">{casino.utils.switchCurrencyKnToEur()}</span></div>
                    </div>
                </td>
            </tr>
        );
    }
    render() {
        return (
            <div>
                {this.renderPobjednike()}
            </div>
        );
    }
};
